import React from 'react';

import { Alert, Button, Checkbox, FormControlLabel, Paper, Stack, TextField } from '@mui/material';

export type PaymentCaptureCardProps = {
  seatPaymentCollected: boolean;
  onPaymentCollectedChange: (value: boolean) => void;
  seatPaymentReference: string;
  onPaymentReferenceChange: (value: string) => void;
  onSave: () => void;
  isSaving: boolean;
  isSaveDisabled?: boolean;
  saveError: string | null;
  saveConfirmation: string | null;
  areAllSelectedSeatsFree: boolean;
};

export default function PaymentCaptureCard({
  seatPaymentCollected,
  onPaymentCollectedChange,
  seatPaymentReference,
  onPaymentReferenceChange,
  onSave,
  isSaving,
  isSaveDisabled,
  saveError,
  saveConfirmation,
  areAllSelectedSeatsFree,
}: PaymentCaptureCardProps): React.JSX.Element {
  const isPaymentFieldsDisabled = areAllSelectedSeatsFree;

  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Stack spacing={3}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={seatPaymentCollected}
                onChange={(event) => onPaymentCollectedChange(event.target.checked)}
                disabled={isPaymentFieldsDisabled}
              />
            }
            label="Payment collected"
            sx={{ mr: { sm: 0 } }}
          />
          <TextField
            label="Payment reference"
            value={seatPaymentReference}
            onChange={(event) => onPaymentReferenceChange(event.target.value)}
            placeholder={seatPaymentCollected ? 'Enter payment reference' : 'Enter payment reference (optional)'}
            fullWidth
            disabled={!seatPaymentCollected || isPaymentFieldsDisabled}
            required={seatPaymentCollected}
            helperText={
              isPaymentFieldsDisabled
                ? 'Payment not required for free seats.'
                : seatPaymentCollected
                ? 'Required when payment is collected.'
                : undefined
            }
            sx={{ maxWidth: { sm: 320 } }}
          />
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}>
          <Button variant="contained" onClick={onSave} sx={{ minWidth: 160 }} disabled={isSaving || isSaveDisabled}>
            {isSaving ? 'Saving…' : 'Save selection'}
          </Button>
          {saveConfirmation ? <Alert severity="success">{saveConfirmation}</Alert> : null}
          {saveError ? <Alert severity="error">{saveError}</Alert> : null}
        </Stack>
      </Stack>
    </Paper>
  );
}
